import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './layout/AppShell';
import { HomePage } from './pages/HomePage';
import { ScreensPage } from './pages/ScreensPage';
import { DisplayManagePage } from './pages/displays/manage/DisplayManagePage';
import { ContentPage } from './pages/ContentPage';
import { PlaylistsPage } from './pages/PlaylistsPage';
import { FleetPage } from './pages/FleetPage';
import { CommandOperationsPage } from './pages/CommandOperationsPage';
import { SchedulePage } from './pages/SchedulePage';
import { GroupsPage } from './pages/GroupsPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminPage } from './pages/AdminPage';
import { TeamsPage } from './pages/TeamsPage';
import { VideoWallsPage } from './pages/VideoWallsPage';
import { LayoutsPage } from './pages/LayoutsPage';
import { DesignerPage } from './pages/DesignerPage';
import { ActivityPage } from './pages/ActivityPage';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/auth/AuthCallbackPage';
import { ChooseOrganisationPage } from './pages/choose-organisation/ChooseOrganisationPage';
import { PairDevicePage } from './pages/pair/PairDevicePage';
import { RequireAuth, RequireOrganisation } from './lib/guards';
import { SupabaseSessionSync } from './lib/SupabaseSessionSync';

export function App() {
  return (
    <>
      <SupabaseSessionSync />
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="auth/callback" element={<AuthCallbackPage />} />
        <Route
          path="setup"
          element={
            <RequireAuth>
              <ChooseOrganisationPage />
            </RequireAuth>
          }
        />
        <Route
          path="pair"
          element={
            <RequireAuth>
              <RequireOrganisation>
                <PairDevicePage />
              </RequireOrganisation>
            </RequireAuth>
          }
        />
        <Route
          element={
            <RequireAuth>
              <RequireOrganisation>
                <AppShell />
              </RequireOrganisation>
            </RequireAuth>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="screens" element={<ScreensPage />} />
          <Route path="screens/:screenId" element={<DisplayManagePage />} />
          <Route path="content" element={<ContentPage />} />
          <Route path="playlists" element={<PlaylistsPage />} />
          <Route path="fleet" element={<FleetPage />} />
          <Route path="command-operations" element={<CommandOperationsPage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="activity" element={<ActivityPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="teams" element={<TeamsPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="video-walls" element={<VideoWallsPage />} />
          <Route path="layouts" element={<LayoutsPage />} />
          <Route path="designer" element={<DesignerPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
